document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collage-section').forEach(section => {
    const slider = section.querySelector('.collage-slider');
    const collageStyle = section.classList.contains('collage-style-slider');
    let currentIndex = -1;
    let items = [];

    const modal = section.querySelector(".modal");
    const modalImage = modal.querySelector(".modalImage");
    const modalTitle = modal.querySelector(".modalTitle");
    const modalDescription = modal.querySelector(".modalDescription");
    const closeModalBtn = modal.querySelector(".modal-close");
    const prevBtn = modal.querySelector(".modal-prev");
    const nextBtn = modal.querySelector(".modal-next");
    const shopTheLookBtn = modal.querySelector(".shop-the-look-btn");

    function adjustLayout() {
      const collageItems = section.querySelectorAll('.collage-slider .collage-item');
      const totalItems = collageItems.length;
      const visibleItems = Array.from(collageItems).filter(el => el.offsetParent !== null);
      const slidesToShow = Math.min(visibleItems.length || totalItems, 5);

      if (!collageStyle) {
        if (window.innerWidth > 901 && totalItems > 0 && totalItems < 5) {
          const flexValue = `0 0 calc(100% / ${totalItems})`;
          collageItems.forEach(item => item.style.flex = flexValue);
        } else {
          collageItems.forEach(item => item.style.flex = '');
        }
        return;
      }

      if (!window.jQuery || !$.fn.slick) {
        console.warn('Slick.js no está cargado.');
        return;
      }

      if ($(slider).hasClass('slick-initialized')) {
        $(slider).slick('unslick');
      }

      const images = slider.querySelectorAll('img');
      let imagesLoaded = 0;

      function initializeSlick() {
        $(slider).slick({
          slidesToShow,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
          autoplay: false,
          variableWidth: false,
          centerPadding: '0px',
          draggable: true,
          swipe: true,
          touchMove: true,
          prevArrow: section.querySelector('.collage-slider-prev'),
          nextArrow: section.querySelector('.collage-slider-next'),
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '40px',
              },
            },
          ],
        });
      }

      if (images.length === 0) {
        initializeSlick();
      } else {
        images.forEach(img => {
          if (img.complete) {
            imagesLoaded++;
          } else {
            img.addEventListener('load', () => {
              imagesLoaded++;
              if (imagesLoaded === images.length) {
                initializeSlick();
              }
            });
          }
        });

        if (imagesLoaded === images.length) {
          initializeSlick();
        }
      }
    }

    // Primer render con delay para asegurar layout final
    setTimeout(adjustLayout, 100);

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(adjustLayout, 300);
    });

    const collageContainer = section.querySelector('.collage-slider, .collage-grid, .collage-container');
    if (collageContainer) {
      items = Array.from(collageContainer.querySelectorAll('.collage-item'));
      collageContainer.addEventListener('click', (e) => {
        const item = e.target.closest('.collage-item');
        if (item) {
          currentIndex = items.indexOf(item);
          openModal(currentIndex);
        }
      });
    }

    function openModal(index) {
      if (index < 0 || index >= items.length) return;
      const item = items[index];

      modalImage.src = item.getAttribute("data-image") || "";
      modalTitle.textContent = item.getAttribute("data-title") || "";
      modalDescription.textContent = item.getAttribute("data-description") || "";

      const productUrl = item.getAttribute("data-shop-url") || "";
      const buttonPosX = item.getAttribute("data-button-x") || "50";
      const buttonPosY = item.getAttribute("data-button-y") || "50";

      if (productUrl) {
        shopTheLookBtn.style.display = "block";
        shopTheLookBtn.style.left = buttonPosX + "%";
        shopTheLookBtn.style.top = buttonPosY + "%";
        shopTheLookBtn.onclick = () => window.location.href = productUrl;
      } else {
        shopTheLookBtn.style.display = "none";
      }

      const modalContent = modal.querySelector(".modal-content");
      modalContent.style.transform = "scale(1)";
      modalContent.style.opacity = "1";

      modal.classList.add("show");
      document.body.classList.add("modal-open");
    }

    function closeModal() {
      if (window.gsap) {
        gsap.fromTo(
          modal.querySelector(".modal-content"),
          { scale: 1, opacity: 1 },
          {
            scale: 0.8,
            opacity: 0,
            duration: 0.4,
            ease: "power3.in",
            onComplete: () => {
              modal.classList.remove("show");
              document.body.classList.remove("modal-open");
            },
          }
        );
      } else {
        modal.classList.remove("show");
        document.body.classList.remove("modal-open");
      }
    }

    function navigateModal(step) {
      if (!items.length) return;
      currentIndex = (currentIndex + step + items.length) % items.length;
      openModal(currentIndex);
    }

    prevBtn?.addEventListener('click', () => navigateModal(-1));
    nextBtn?.addEventListener('click', () => navigateModal(1));
    closeModalBtn?.addEventListener('click', closeModal);
    modal?.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains('show')) return;
      if (e.key === 'ArrowLeft') navigateModal(-1);
      if (e.key === 'ArrowRight') navigateModal(1);
      if (e.key === 'Escape') closeModal();
    });
  });
});
